import {
  LOAD_SONG_DISCOVERY,
  UNLOAD_CURRENT_ARTIST,
  UNLOAD_CURRENT_SONG,
} from '../../actionTypes';
import { loadReducer } from '../helpers';

export const discovery = (state = null, action) => {
  switch (action.type) {
    case UNLOAD_CURRENT_ARTIST:
    case UNLOAD_CURRENT_SONG:
      return null;

    case LOAD_SONG_DISCOVERY:
      return loadReducer(state, action);
    default:
      return state;
  }
};
